// Simple Rule-Based AI Engine
// It takes user input, matches it against predefined rules, and returns a response.

export const predefinedQuestions = [
  "What services do you offer?",
  "How much does a project cost?",
  "How long does it take?",
  "Do you provide support?",
  "What technologies do you use?",
  "Where are you located?"
];

const rules = [
  {
    pattern: /hello|hi|hey|greetings/i,
    response: "Hello! I am the TSIL assistant. How can I help you today?",
    suggestedQuestions: ["What services do you offer?", "Tell me about your projects", "Who are you?"]
  },
  {
    pattern: /cost|price|pricing|how much|budget|fee/i,
    response: "Project costs vary widely depending on the scope, features, and complexity. We offer competitive pricing and would love to provide a custom quote if you reach out via our Contact page.",
    suggestedQuestions: ["How long does it take?", "What technologies do you use?", "How can I contact you?"]
  },
  {
    pattern: /time|how long|timeframe|duration|deadline/i,
    response: "A typical web or mobile project can take anywhere from 4 to 12 weeks. The exact timeframe depends on your specific requirements and the complexity of the solution.",
    suggestedQuestions: ["How much does a project cost?", "Do you build mobile apps?", "What services do you offer?"]
  },
  {
    pattern: /support|maintenance|after launch|help/i,
    response: "Yes! We provide ongoing support and maintenance packages after launch to ensure your software remains secure, updated, and running smoothly.",
    suggestedQuestions: ["What technologies do you use?", "How much does a project cost?"]
  },
  {
    pattern: /tech|technolog|frameworks|react|node|languages/i,
    response: "We utilize modern tech stacks including React, Node.js, modern CSS frameworks, and scalable cloud infrastructure to build robust and future-proof solutions.",
    suggestedQuestions: ["Tell me about web development", "Do you build mobile apps?", "What services do you offer?"]
  },
  {
    pattern: /services?|what do you do|what can you do|offer/i,
    response: "We offer Web Design & Development, Mobile App Development, Cloud Solutions, Cybersecurity, Data Analytics, Logistics systems, and IT Consulting.",
    suggestedQuestions: ["Tell me about Cloud Solutions", "What is your web development process?", "Tell me about Data Analytics"]
  },
  {
    pattern: /cloud|security|cybersecurity|data analytics/i,
    response: "We offer robust Cloud Solutions for scalability, top-tier Cybersecurity to protect digital assets, and Data Analytics to provide data-driven insights empowering business decisions.",
    suggestedQuestions: ["What technologies do you use?", "Tell me about web development", "How can I contact you?"]
  },
  {
    pattern: /web|website|web design|web development|ecommerce/i,
    response: "Our web development team creates stunning, responsive websites and eCommerce platforms that captivate audiences and drive conversions, handling everything from UI/UX design to final deployment.",
    suggestedQuestions: ["Tell me about your projects", "What technologies do you use?", "How much does a project cost?"]
  },
  {
    pattern: /app|mobile|ios|android/i,
    response: "We build high-performance iOS and Android applications with seamless UX, helping businesses reach customers anywhere, anytime.",
    suggestedQuestions: ["Tell me about the KGVL app", "What technologies do you use?", "How much does a project cost?"]
  },
  {
    pattern: /brand|marketing|campaign|seo/i,
    response: "From identity design to digital campaigns and SEO, we build brands that resonate. Our approach is strategy-led, creative-first, and results-obsessed.",
    suggestedQuestions: ["Tell me about web development", "What services do you offer?"]
  },
  {
    pattern: /logistic|shipping|supply chain/i,
    response: "We provide end-to-end logistics management systems that streamline operations, reduce costs, and deliver real-time visibility. Examples include our work with USTL and TWI.",
    suggestedQuestions: ["Tell me about USTL", "What technologies do you use?", "What services do you offer?"]
  },
  {
    pattern: /pure prakrati/i,
    response: "Pure Prakrati is a user-friendly app we helped build. It's designed to help businesses reduce carbon emissions in road logistics, promoting sustainability.",
    suggestedQuestions: ["Tell me about your projects", "What is the KGVL app?", "Do you build mobile apps?"]
  },
  {
    pattern: /kgvl|karishma/i,
    response: "For KGVL, we built a hybrid mobile app that revolutionizes transportation by helping bike owners convert their petrol bikes into hybrid smart E-mobility solutions.",
    suggestedQuestions: ["Tell me about Pure Prakrati", "Do you build mobile apps?", "Tell me about your projects"]
  },
  {
    pattern: /ustl|trans world/i,
    response: "USTL (USTRANS WORLD LOGISTICS LIMITED) is one of our major logistics projects. We provided an integrated dashboard solution for their freight forwarding operations.",
    suggestedQuestions: ["Tell me about logistics software", "Tell me about your projects", "What technologies do you use?"]
  },
  {
    pattern: /devta|gensets/i,
    response: "We worked with Devta Gensets, a leading provider of power solutions with three decades of experience, delivering consulting and a custom CMS.",
    suggestedQuestions: ["Tell me about your projects", "Tell me about web development", "What services do you offer?"]
  },
  {
    pattern: /projects?|work|portfolio|clients|experience/i,
    response: "We've delivered 10+ major projects including the KGVL Hybrid App, Pure Prakrati sustainability app, USTL logistics dashboard, and Devta Gensets CMS. Check our Projects page for details.",
    suggestedQuestions: ["Tell me about the KGVL app", "Tell me about Pure Prakrati", "Tell me about USTL"]
  },
  {
    pattern: /contact|email|phone|reach|hire/i,
    response: "You can reach us through the Contact Us page! Whether you're looking to hire us for a project or just want to say hi, we'd love to hear from you.",
    suggestedQuestions: ["Where are you located?", "What services do you offer?"]
  },
  {
    pattern: /locate|location|where|address|office/i,
    response: "We are an India-based tech company serving innovative businesses worldwide.",
    suggestedQuestions: ["How can I contact you?", "What services do you offer?", "Are you hiring?"]
  },
  {
    pattern: /values|culture/i,
    response: "Our core values are Innovation, Integrity, Customer-centricity, Collaboration, Excellence, and Adaptability. We prioritize client needs and ethical practices.",
    suggestedQuestions: ["What is your mission?", "Who are you?", "What is your vision?"]
  },
  {
    pattern: /mission|vision/i,
    response: "Our mission is to deliver high-quality digital solutions empowering businesses. Our vision is to be at the forefront of technological innovation, making world-class solutions accessible.",
    suggestedQuestions: ["What are your values?", "Who are you?", "What services do you offer?"]
  },
  {
    pattern: /about|tsil|transvue|who are you|founded/i,
    response: "TSIL (Transvue Solutions India Private Limited) is a leading IT services provider founded in 2024. We evolved from a startup to delivering impactful digital products globally.",
    suggestedQuestions: ["What is your mission?", "What services do you offer?", "What are your values?"]
  },
  {
    pattern: /career|hiring|job|internship/i,
    response: "We are always on the lookout for talented individuals! Please reach out via our Contact page to inquire about current openings.",
    suggestedQuestions: ["Where are you located?", "How can I contact you?"]
  },
  {
    pattern: /thank you|thanks|appreciate/i,
    response: "You're very welcome! Let me know if you need anything else.",
    suggestedQuestions: ["What services do you offer?", "Where are you located?"]
  }
];

export function getAIResponse(input) {
  for (let rule of rules) {
    if (rule.pattern.test(input)) {
      return { 
        responseText: rule.response, 
        suggestedQuestions: rule.suggestedQuestions || predefinedQuestions 
      };
    }
  }
  return {
    responseText: "I'm sorry, I didn't quite catch that. Could you please rephrase or select one of the suggested questions above?",
    suggestedQuestions: predefinedQuestions
  };
}
